import { ROOM_RATE_FLASH_TYPE } from '~/consts/ratePlans';

import { formatFlashRatePlanName } from '../utils';

export const RATE_PLAN_FORM_ID = 'flash-offer-rate-plan-form';
export const FLASH_RATE_PLAN_STATUS = 'content-approved';
export const FLASH_RATE_PLAN_PRODUCT_TYPE = ROOM_RATE_FLASH_TYPE;
export const FLASH_RATE_PLAN_RATE_TYPE = 'gross';

export type RatePlanCreateSchema = {
  properties?: Record<string, { enum?: Array<string> }>;
};

type RatePlanSelectField = 'cancellation_policy' | 'status' | 'product_type' | 'rate_type';

type RatePlanValidationParams = {
  ratePlanCancellationPolicy: string;
  ratePlanName: string;
  ratePlanProductType: string;
  ratePlanRateType: string;
  ratePlanStatus: string;
};

export function getDefaultFlashRatePlanName(date = new Date()) {
  return formatFlashRatePlanName(date);
}

export function getRatePlanEnumOptions(
  schema: RatePlanCreateSchema | undefined,
  field: RatePlanSelectField,
  currentValue: string,
) {
  const schemaOptions = schema?.properties?.[field]?.enum?.filter(Boolean) ?? [];

  return currentValue && !schemaOptions.includes(currentValue) ? [currentValue, ...schemaOptions] : schemaOptions;
}

export function getRatePlanValidationError({
  ratePlanCancellationPolicy,
  ratePlanName,
  ratePlanProductType,
  ratePlanRateType,
  ratePlanStatus,
}: RatePlanValidationParams) {
  if (!ratePlanName.trim()) {
    return 'Enter a rate plan name.';
  }

  if (
    !ratePlanCancellationPolicy.trim() ||
    !ratePlanStatus.trim() ||
    !ratePlanProductType.trim() ||
    !ratePlanRateType.trim()
  ) {
    return 'Complete all rate plan fields.';
  }

  return null;
}
